import { useMemo } from 'react';

const useFormProperties = (items) => {
  const propertiesMap = useMemo(() => {
    return items.reduce((acc, item) => {
      acc[item.code] = item;
      return acc;
    }, {});
  }, [items]);

  /**
   * @param {string} code Código de la propiedad a consultar
   * @returns {object|null} Devuelve el objeto de la propiedad o null si no existe
   */
  const getProperty = (code) => propertiesMap[code] || null;

  return { propertiesMap, getProperty };
};

export default useFormProperties;
